module.exports = __webpack_public_path__ + "img/logo_vote.a58f7c9b.png";